import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";

library.add(fas);

dom.watch();
